import { AppConfig } from './app-config.model';

interface ConfigEnvironmentItem {
  id: string;
  key: string;
  value: string;
  description: string;
  environment: string;
}

/**
 * Fetches the public environment configuration from cms-bqm-api before Angular bootstraps.
 * Uses native fetch() since HttpClient is not available at this stage.
 *
 * The CMS API URL is the only compile-time dependency — everything else comes from the API.
 */
export async function fetchPublicAppConfig(
  cmsApiUrl: string,
  environmentName: string,
  platform: string
): Promise<AppConfig> {
  const url = `${cmsApiUrl}public/catalog/config-environment/public?environment=${environmentName}&platform=${platform}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to load config: HTTP ${response.status}`);
  }

  const items: ConfigEnvironmentItem[] = await response.json();
  return mapItemsToAppConfig(items);
}

/**
 * Applies an array of { key, value } pairs from the API response into a typed AppConfig.
 * Keys in the DB match exactly the AppConfig field names.
 */
export function mapItemsToAppConfig(items: ConfigEnvironmentItem[]): AppConfig {
  const raw = Object.fromEntries(items.map((item) => [item.key, item.value]));
  return raw as unknown as AppConfig;
}
